import MyCompanyStar from './MyCompanyStar'
import * as actions from './my-company-star-actions'
import * as constants from './my-company-star-constants'
import reducer from '../../entities/my-entity-star/my-entity-star-reducer'
import saga from './my-company-star-saga'

export {MyCompanyStar, actions, constants, reducer, saga}
export default MyCompanyStar
